import WomanCard from "../../Home/Components/WomanCard/WomanCard";
import Title from "../../Home/Components/Title/Title";
import { getWomanThumbImageUrl } from "../../../utils/imageUrl";
import { useTranslation } from "../../../i18n/LanguageProvider";

function NewsRemarkableWomenSection({ women }) {
    const { t } = useTranslation();

    if (!women.length) {
        return null;
    }

    return (
        <section className="news-detail__recommendations" aria-labelledby="news-remarkable-women-title">
            <Title id="news-remarkable-women-title" text={t("home.remarkable")} />
            <div className="news-detail__recommendations-grid">
                {women.map((woman) => (
                    <WomanCard
                        key={woman.id}
                        id={woman.id}
                        name={woman.name}
                        surname={woman.surname}
                        domain={woman.category_name}
                        categoryColor={woman.category_color}
                        image={getWomanThumbImageUrl(woman.image)}
                    />
                ))}
            </div>
        </section>
    );
}

export default NewsRemarkableWomenSection;
